

















































































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import {卸別入出庫集計依頼型, 卸別入出庫集計型, 卸型, 品目別入出庫表示依頼型, 品目別入出庫集計型} from '@/type/stock/summary/receive_delivery_summary';
import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import {progress} from '@/script/progress';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import WholesaleSelector from '@/components/wholesale/WholesaleSelector.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';

@Component({
  components: {
    NormalDialog,
    WholesaleSelector,
    ConfirmDialog,
    NormalButton,
  },
})
export default class ReceiveDeliveryItemDetails extends Vue {
  @Prop({default: false})
  private modal!: boolean;
  @Prop()
  private wholesalesInSummaries!: 卸型[];
  @Prop()
  private summaryData!: 卸別入出庫集計型;
  @Prop()
  private summaryCondition!: 卸別入出庫集計依頼型;

  private 集計一覧に含まれる卸一覧: 卸型[] = [];
  private 品目別入出庫集計一覧: 品目別入出庫集計型[] = [];

  private 選択中の行index: number | null = null;
  private 選択中卸コード: string | null = null;

  @Watch('modal')
  private async ダイアログ表示状態変更(nowModal: boolean, prevModal: boolean) {
    if (nowModal === true) {
      this.集計一覧に含まれる卸一覧 = this.wholesalesInSummaries;
      this.選択中卸コード = this.summaryData.卸コード;

      this.品目別入出庫集計一覧 = [];
      const 品目別入出庫表示依頼 = this.品目別入出庫表示依頼を生成する();
      await api.品目別入出庫を集計する(品目別入出庫表示依頼)
        .then((response: 品目別入出庫集計型[]) => {
          this.品目別入出庫集計一覧 = response;
          this.$modal.show('品目情報');
        })
        .catch((error: any) => {
          this.$emit('show-alert', error.data.message);
        });
    }
  }

  @Emit('close')
  private 閉じる(): void {
    this.$modal.hide('品目情報');
  }

  private 行が選択されている(index: number) {
    return this.選択中の行index === index;
  }

  private async リスト選択時の処理(index: number) {
    this.選択中の行index = index;
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private async 合計出力する(): Promise<void> {
    const 品目別入出庫表示依頼 = this.品目別入出庫表示依頼を生成する();

    await download.品目別入出庫一覧表を出力する('卸別入出庫集計表_品目別.xlsx', 品目別入出庫表示依頼);
    this.ダイアログを閉じる('合計出力ダイアログ');
  }

  private async 合計出力するハンドラ(): Promise<void> {
    await progress(this.合計出力する);
  }

  private async 再表示する(): Promise<void> {

    this.品目別入出庫集計一覧 = [];
    const 品目別入出庫表示依頼 = this.品目別入出庫表示依頼を生成する();
    await api.品目別入出庫を集計する(品目別入出庫表示依頼)
      .then((response: 品目別入出庫集計型[]) => {
        this.品目別入出庫集計一覧 = response;
        this.$modal.show('品目情報');
      })
      .catch((error: any) => {
        this.$emit('show-alert', error.data.message);
      });

    this.ダイアログを閉じる('再表示確認ダイアログ');
  }

  private async 再表示するハンドラ(): Promise<void> {
    await progress(this.再表示する);
  }

  private async 入庫明細を出力する(): Promise<void> {
    const 品目別入出庫表示依頼 = this.品目別入出庫表示依頼を生成する();

    await download.品目別明細入出庫一覧表を出力する('卸別入出庫集計表_品目別明細.xlsx', 品目別入出庫表示依頼);
    this.ダイアログを閉じる('入庫明細ダイアログ');
  }

  private async 入庫明細を出力するハンドラ(): Promise<void> {
    await progress(this.入庫明細を出力する);
  }

  private 品目別入出庫表示依頼を生成する(): 品目別入出庫表示依頼型 {
    return {
      卸コード: this.選択中卸コード,
      集計期間From: this.summaryCondition.集計期間From,
      集計期間To: this.summaryCondition.集計期間To,
    };
  }
}
